import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'surr-req-reject-case',
  templateUrl: './surr-req-reject-case.component.html'
})
export class SurrReqRejectComponent implements OnInit {
  rejectForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    this.rejectForm = new FormGroup({
      rejectReason: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(2000)])
    });  
  }


  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  reject() {

    if (!this.rejectForm.value.rejectReason){
      this.showErrorToast("Please Enter Reject Reason");
    }

    if (this.rejectForm.valid) {
      return this.modalCtrl.dismiss(this.rejectForm.value.rejectReason, 'reject');
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

}
